// Row id derivation.
//
// rowId = hash(uuid, authorId), or hash(uuid) for unauthored rows.
// Authorship is implicit in the insert op; there is no separate owner/recipient
// payload field, but the authored id space remains partitioned by author key.
import { json } from "@hyper-hyper-space/hhs3_json";
import { sha256, stringToUint8Array } from "@hyper-hyper-space/hhs3_crypto";
export function deriveRowId(uuid, author) {
    const canonical = author === undefined
        ? { uuid }
        : { uuid, author };
    return sha256.hashToB64(stringToUint8Array(json.toStringNormalized(canonical)));
}
export function checkRowId(rowId, uuid, author) {
    return deriveRowId(uuid, author) === rowId;
}
// Table id derivation: tables have no creation op (they exist by schema), so
// their object ids are derived deterministically from (groupId, tableName).
export function deriveTableId(groupId, table) {
    const canonical = { group: groupId, table };
    return sha256.hashToB64(stringToUint8Array(json.toStringNormalized(canonical)));
}
